<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/L4dBTg/tc-custom/9781398430235.jpg?1685328099104" alt="This image is the cover for the book Skylark and the Dragon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Skylark and the Dragon
      </h1>
      <p class="bookDescription body article font2">
        <p>Skylark and the Dragon is an adventure about some grandparents who travel to Iceland only to discover a dragon, a host of Degus (South American rats from Chile) and a nasty Octopus called Virginia. <br/>What will happen to the Dragon? Will the grandparents step up as heroes?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gigga Black, Daniel Belben
      </h2>
      
      <p class="authorDescription body article">After having visited Iceland in 2019, Gigga Black, an ex retailer and carer was inspired by her pet Degu Skylark, and Mr Catchpole and Mr Terence White, who she based Terence the Dragon on. She is hoping to move to Iceland or France in the future and continue to create children's books, audiobooks, and animations. She is inspired by the natural world, art history, myths, legends and all wonderful creatures in the universe. She has a lovely niece called Phoebe and lives in Dorset.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?661400de